( function( global, $ ) {
    "use strict";

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        function isOptionFound(input, options) {
            var sanitizedInput = input.trim().toLowerCase(),
                found = false;

            $.each(options, function() {
                if (this.text.trim().toLowerCase() === sanitizedInput) {
                    found = true;

                    return false;
                }
            });

            return found;
        }

        $container.find('[selectize-default]').selectize({
            maxOptions: 5000,
            highlight: false,
            onType: function (value) {
                this.$dropdown_content.unmark().mark(value);
            }
        });

        // $container.find('[selectize-time]').selectize({
        //     create: true,
        //     render: {
        //         option_create: function (data, escape) {
        //             if (! isOptionFound(data.input, this.options)) {
        //                 return '<div class="create">Créer <strong>' + escape(data.input) + '</strong>&hellip;</div>';
        //             }
        //         }
        //     }
        // });

        $container.find('[selectize-create]').selectize({
            maxOptions: 5000,
            highlight: false,
            onType: function (value) {
                this.$dropdown_content.unmark().mark(value, {exclude: ['.create *']});
            },
            create: function(input) {
                return {value: '*new*: ' + input, text: input}
            },
            render: {
                option_create: function (data, escape) {
                    if (! isOptionFound(data.input, this.options)) {
                        return '<div class="create">Créer <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                    }
                }
            }
        });

        // $container.find('[selectize-create-link]').selectize({
        //     create: function(input, callback) {
        //         var link = this.$input.data('link').replace(/_name_/g, encodeURI(input));
        //
        //         window.location.assign(link);
        //
        //     },
        //     render: {
        //         option_create: function (data, escape) {
        //             if (! isOptionFound(data.input, this.options)) {
        //                 return '<div class="create">Créer <strong>' + escape(data.input) + '</strong>&hellip;</div>';
        //             }
        //         }
        //     }
        // });

        $container.find('[selectize-multiple]').selectize({
            maxOptions: 5000,
            plugins: ['remove_button'],
            delimiter: ',',
            persist: false,
            highlight: false,
            onType: function (value) {
                this.$dropdown_content.unmark().mark(value);
            }
        });

        $container.find('[selectize-multiple-create]').selectize({
            maxOptions: 5000,
            plugins: ['remove_button'],
            delimiter: ',',
            persist: false,
            highlight: false,
            onType: function (value) {
                this.$dropdown_content.unmark().mark(value, {exclude: ['.create *']});
            },
            create: function(input) {
                return {value: '*new*: ' + input, text: input}
            },
            render: {
                option_create: function (data, escape) {
                    if (! isOptionFound(data.input, this.options)) {
                        return '<div class="create">Créer <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                    }
                }
            }
        });

        $container.find('[selectize-clear]').on('click', function(ev) {
            ev.preventDefault();

            var $selectize = $(this).siblings('select'),
                selectize = $selectize.get(0).selectize;

            selectize.clear();
        });

        //Helper function
        var forEach = function (array, callback, scope) {
            for (var i = 0; i < array.length; i++) {
                callback.call(scope, i, array[i]); // passes back stuff we need
            }
        };

        $container.find('.selectize-input').each(function(){
            if($(this).find('.item').length > 0) {
                $(this).parent('.selectize-control').siblings('.form-selectize-clear').removeClass('ghost');
            } else {
                $(this).parent('.selectize-control').siblings('.form-selectize-clear').addClass('ghost');
            }
        });

        //Observing selectize inputs
        /*var selectizeInputs = document.querySelectorAll('.selectize-input input')
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                forEach(selectizeInputs, function(index) {
                    if (selectizeInputs[index].att) {
                        selectizeInputs[index]
                    } el
                });
            });
        });

        forEach(selectizeInputs, function(index) {
            observer.observe(selectizeInputs[index], { attributeOldValue: true });
        });*/

    });

}( window.groots, jQuery ));
